module.exports = __webpack_public_path__ + "media/images/search-35a687c688206c5bc75ab3aaee2068b1.svg";